import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const BACKEND_BASEURL = process.env.REACT_APP_BACKEND_URL;

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_BASEURL}api`,
    credentials: "include",
  }),

  tagTypes: [
    "UOMs",
    "Customer",
    "Ingredient",
    "Waiter",
    "Notification",
    "Table",
    "Purchase",
    "Item",
    "InventoryAdjust",
    "DayStart",
    "Category",
    "Order",
    "Cash",
    "Expense",
    "Vendor",
    "updateVender",
    "completeOrder",
    "Cook",
    "UpdatePurchase",
  ],

  endpoints: () => ({}),
});
